import MoreVert from '@mui/icons-material/MoreVert'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import React, { useCallback, useState, type MouseEvent } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import CreateInvoiceIconButton from 'components/common/payments/CreateInvoiceIconButton'
import TakePaymentIconButton from 'components/common/payments/TakePaymentIconButton'
import AccountHeaderActionMenu from 'components/customer-details/content/account-details/header/AccountHeaderActionMenu'
import AccountStatusToggleIconButton from 'components/customer-details/content/common/ReactivateAccountIconButton'
import { canUpdateCustomerManager } from 'data/permissions/permissionsSelectors'
import { get } from 'utils/lodash'

interface AccountActionsToolbarProps {
  accountId: string
}

interface CustomerDetailsSlice {
  active?: boolean
  accountBilling?: { billingProfile?: Record<string, unknown> }
}

const AccountActionsToolbar = ({ accountId }: AccountActionsToolbarProps) => {
  const customerDetails = useSelector((state: unknown): CustomerDetailsSlice | null => get(state, 'CustomersReducer.customerDetails', null))
  const showAccountActionMenu = useSelector(canUpdateCustomerManager, shallowEqual)
  const [accountActionMenuAnchorEl, setAccountActionMenuAnchorEl] = useState<HTMLElement | null>(null)

  const isActiveAccount = customerDetails?.active
  const billingProfileDetails = customerDetails?.accountBilling?.billingProfile ?? {}

  const handleCloseActionsMenu = useCallback(() => setAccountActionMenuAnchorEl(null), [])
  const handleOpenActionsMenu = useCallback((event: MouseEvent<HTMLElement>) => setAccountActionMenuAnchorEl(event.currentTarget), [])

  return (
    <>
      <Grid container alignItems="center" flexWrap="nowrap">
        {!isActiveAccount && (
          <Grid>
            <AccountStatusToggleIconButton accountId={accountId} customerDetails={customerDetails} />
          </Grid>
        )}
        <Grid>
          <TakePaymentIconButton accountId={accountId} />
        </Grid>
        <Grid>
          <CreateInvoiceIconButton accountId={accountId} billingProfileDetails={billingProfileDetails} />
        </Grid>
        <Grid>
          {showAccountActionMenu && (
            <IconButton onClick={handleOpenActionsMenu}>
              <MoreVert />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <AccountHeaderActionMenu accountId={accountId} anchorEl={accountActionMenuAnchorEl} onClose={handleCloseActionsMenu} />
    </>
  )
}

export default AccountActionsToolbar
